module.exports = __webpack_public_path__ + "img/1@2x.8d0b6118.png";